import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-button">
          <ArrowLeft size={20} />
          Back to Home
        </Link>

        <h1 className="legal-title">Terms and Conditions</h1>
        <p className="legal-date">Last Updated: December 2025</p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Sygmatec Smart Solutions website and services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Use of Services</h2>
            <p>
              You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:
            </p>
            <ul>
              <li>Use our services in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the integrity or performance of our services</li>
              <li>Transmit any viruses, malware, or other harmful code</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Intellectual Property</h2>
            <p>
              All content, features, and functionality on our website are owned by Sygmatec Smart Solutions and are protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Service Availability</h2>
            <p>
              We strive to maintain continuous availability of our services but do not guarantee uninterrupted access. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without notice.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Sygmatec Smart Solutions shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of any third-party sites.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Sygmatec Smart Solutions from any claims, damages, losses, liabilities, and expenses arising from your use of our services or violation of these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the updated Terms on our website. Your continued use of our services after such changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Sygmatec Smart Solutions operates, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Contact Information</h2>
            <p>
              For questions about these Terms and Conditions, please contact us at:
            </p>
            <p>
              <strong>Sygmatec Smart Solutions</strong><br />
              21-111, 7th Cross Road<br />
              Uttamnagar, Safilguda<br />
              Hyderabad - 500047<br /><br />
              Email: Info@hs-sygmatec.com | Info@sygmatec.in<br />
              Phone: +91 407069565
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
